import { FC } from "react";
import "./ChatMenuItem.scss";

export interface ChatMenuItemProps {
    onClick?: (label: string) => void;
    readonly label: string;
    readonly subtitle?: string;
    readonly tabIndex?: string;
}

const ChatMenuItem: FC<ChatMenuItemProps> = (props) => {
    function handleClick() {
        if (props.onClick) {
            props.onClick(props.label);
        }
    }

    const content = props.subtitle ? (
        <span>
            <div>{props.label}</div>
            <div className="chat-menu-item--subtitle">{props.subtitle}</div>
        </span>
    ) : (
        <span>{props.label}</span>
    );

    return (
        <button
            type="button"
            className="chat-menu-item"
            tabIndex={props.tabIndex ? Number(props.tabIndex) : 0}
            onClick={handleClick}>
            {content}
        </button>
    );
};

export default ChatMenuItem;
